export const FRONT_END_SKILLS = [
  { nom: "HTML",       image: "/assets/img/icon/stack/html.webp" },
  { nom: "CSS",        image: "/assets/img/icon/stack/css.webp" },
  { nom: "JavaScript", image: "/assets/img/icon/stack/JavaScript-logo.webp" },
  { nom: "TypeScript", image: "/assets/img/icon/stack/typescript.webp" },
  { nom: "React",      image: "/assets/img/icon/stack/react.webp" },
  { nom: "Next.js 14", image: "/assets/img/icon/stack/nextjs.webp" },
  { nom: "Bootstrap",  image: "/assets/img/icon/stack/bootstrap.webp" },
];
